import { FC, useEffect } from 'react';

import {
  Button,
  Form,
  FormField,
  Heading,
  Input,
  Text,
} from '@livechat/design-system-react-components';

import { SigninFormData, FormStates } from 'types/form';
import Amplitude from 'services/Amplitude';

import * as styles from './styles';

type Props = {
  formData: SigninFormData;
  onPasswordInputChange: (e: any) => void;
  onSubmit: (event: any) => Promise<void>;
  onSignInClick: () => void;
  formState: string;
  validationError: string;
};

export const SignInRequestAccessRedirectForm: FC<Props> = ({
  formData,
  onPasswordInputChange,
  onSubmit,
  onSignInClick,
  formState,
  validationError,
}) => {
  const { email } = formData;

  useEffect(() => {
    Amplitude.logEvent(email, 'SIGNIN_REQUEST_ACCESS_REDIRECT');
  }, []);

  return (
    <div data-testid="signin-request-access-redirect-form">
      <div css={styles.headerContainer}>
        <Heading size="lg">Approve invite</Heading>
        <Text data-testid="signin-request-access-redirect-text">
          Log in as <b>{email}</b> to approve invite
        </Text>
      </div>
      <Form onSubmit={onSubmit}>
        <FormField labelText="Business email" labelFor="email" css={styles.formHiddenField}>
          <Input
            type="email"
            name="email"
            placeholder="name@work-email.com"
            value={email}
            inputSize="large"
          />
        </FormField>
        <FormField
          labelText="Password"
          labelFor="password"
          error={validationError}
          css={styles.formField}
        >
          <Input
            type="password"
            name="password"
            placeholder="12 characters or more"
            id="sign-in-password-field"
            inputSize="large"
            onChange={onPasswordInputChange}
            error={!!validationError}
          />
        </FormField>

        <Button
          type="submit"
          kind="primary"
          size="large"
          onClick={onSignInClick}
          loading={formState === FormStates.Requesting}
          data-testid="login-form-button"
          css={styles.logInButton}
        >
          Log in
        </Button>
      </Form>
    </div>
  );
};
